module.exports = __webpack_public_path__ + "static/media/bg_02.2a84d55e.jpg";